import React from 'react';
import { motion, Variants } from 'framer-motion';
import problemStatementPhone from '../../../assets/images/arbventure/problem_statement_phone.webp';
import Constants from '../../../app/utils/constants';
import colors from '../../theme/color';

const ProblemStatementSection = () => {
  const { arbventureProblemStatement } = Constants;

  const textVariant: Variants = {
    hidden: { opacity: 0, x: -150 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: 'easeIn' },
    },
  };

  const imageVariant: Variants = {
    hidden: { opacity: 0, x: 150 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: 'easeIn' },
    },
  };

  return (
    <section className="relative w-full overflow-hidden">
  <div className="w-full px-[20px] md:px-[40px] lg:px-[70px] 2xl:px-[120px] 2xl:pb-10 xl:pb-20 lg:pb-15">
    
    {/* MAIN LAYOUT */}
    <div
  className="flex mt-5 flex-col-reverse items-center justify-between gap-[30px] md:flex-row md:gap-[40px] lg:gap-[100px] 2xl:gap-[140px">
      
      {/* LEFT CONTENT */}
      <motion.div
        variants={textVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.3 }}
        className="w-full lg:w-[55%] text-center lg:text-left xl:ml-15"
      >
        <div
          className="inline-flex items-center justify-center px-[28px] py-[14px]"
          style={{ backgroundColor: colors.arbVentureAccent }}
        >
          <span className="font-gilroy-bold text-[25px] leading-none text-white md:text-[30px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px]">
            {arbventureProblemStatement.badgeText}
          </span>
        </div>

        <p
          className="mt-[28px] font-gilroy-medium text-[18px] leading-[32px] opacity-80 md:text-[20px] md:leading-[36px] lg:text-[20px] lg:leading-[30px] xl:text-[25px] 2xl:text-[32px] xl:leading-[35px] 2xl:leading-[42px]"
          style={{ color: colors.arbVentureTextMuted }}
        >
          {arbventureProblemStatement.description}
        </p>
      </motion.div>

      {/* RIGHT IMAGE */}
<motion.div
  variants={imageVariant}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: false, amount: 0.3 }}
  className="relative flex w-full justify-center lg:w-[45%]"
>
  {/* GLOW */}
  <div
    className="absolute left-[50%] top-[50%] z-0 h-[250px] w-[250px] -translate-x-1/2 -translate-y-1/2 rounded-full blur-[70px] lg:h-[300px] lg:w-[380px] xl:h-[400px] xl:w-[500px] 2xl:h-[600px] 2xl:w-[600px]"
    style={{
      backgroundImage:
        'radial-gradient(circle, rgba(95,153,55,0.7) 0%, rgba(95,153,55,0.35) 45%, rgba(95,153,55,0) 80%)',
    }}
  />

  {/* FLOATING IMAGE */}
  <motion.img
    src={problemStatementPhone}
    alt="ARB Venture property detail mobile screen"
    animate={{
      y: [ 0, 18, 0],
    }}
    transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'easeIn',
    }}
    className="
      relative z-10 object-contain
      w-[240px] h-[240px]
      md:w-[320px] md:h-[320px]
      lg:w-[420px] lg:h-[420px]
      xl:w-[520px] xl:h-[520px]
      2xl:w-[700px] 2xl:h-[700px]
    "
  />
</motion.div>
    </div>
  </div>
</section>
  );
};

export default ProblemStatementSection;